// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZCKOA","colBig":"styles_colBig__wRgz_","colSmall":"styles_colSmall__2-N7U","shopifyNameWrapper":"styles_shopifyNameWrapper__1BEXM"};